export interface FaqItem {
  id: number;
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 1,
    q: "哇偶姐姐是谁？为什么会突然这么火？",
    a: "哇偶姐姐是因一段犀利吐槽视频走红的网络内容创作者，因敢说真话、怼人不含糊的风格迅速圈粉，被网友称为互联网嘴替。近期因早期发言被考古、直播回应态度等问题引发大面积讨论，连续登上各平台热搜，属于典型的走红后舆论反噬现象。",
  },
  {
    id: 2,
    q: "哇偶姐姐的争议到底是什么？有实锤吗？",
    a: "核心争议集中在三方面：一是其营造的耿直人设与早期发言存在反差；二是走红后大量带货引发恰饭质疑；三是面对舆论时的直播回应与公关态度被认为前后矛盾。目前多数内容属于网友观点与考古整理，尚无被多方确认的实锤，建议理性吃瓜。",
  },
  {
    id: 3,
    q: "本页的评价和吐槽数据可靠吗？",
    a: "本站内容均为各平台公开帖文、评论与网友观点的吃瓜式汇总整理，仅反映大众讨论趋势与评论区画风，不代表事实认定，也不构成对任何人的最终评价。讨论热度与占比为简化估算值，供围观参考。",
  },
  {
    id: 4,
    q: "为什么有人说哇偶姐姐是翻车，有人又觉得被网暴？",
    a: "这与不同的关注角度有关。反对者看重人设反差与商业吃相，支持者则强调其敢说的真实感与主动回应的担当。加上平台算法和同温层效应，两边都能找到大量佐证，才会出现风评明显分化的局面。",
  },
  {
    id: 5,
    q: "后续想看事态发展，应该关注什么？",
    a: "建议关注哇偶姐姐本人的正式回应与后续更新、合作方的声明，以及各平台热评的走向。本站热搜榜与时间线板块会持续汇总讨论动态，你也可以订阅热搜快报，第一时间收到风向变化。",
  },
  {
    id: 6,
    q: "我可以在本站投稿或反馈更多线索吗？",
    a: "可以。如果你发现了值得补充的讨论线索或有任何建议，欢迎通过下方订阅表单或反馈入口联系我们。为保持内容客观，我们会对投稿进行核实与筛选后再纳入汇总。",
  },
];